/* ============================================================================
   NailPrinter.ca — Blog Redesign 2026-05-09
   Vanilla JS for: search, category filter, reading progress, sticky TOC, share
   No external dependencies. ~7KB minified.
   ============================================================================ */
(function () {
  'use strict';

  // -------------------- BLOG INDEX: filter + search --------------------
  function initBlogIndex() {
    var grid = document.querySelector('[data-np-blog-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-np-card]'));
    var search = document.querySelector('[data-np-search]');
    var clearBtn = document.querySelector('[data-np-search-clear]');
    var chips = Array.prototype.slice.call(document.querySelectorAll('[data-np-chip]'));
    var empty = document.querySelector('[data-np-empty]');
    var resetBtn = document.querySelector('[data-np-reset]');
    var pagination = document.querySelector('[data-np-pagination]');

    var state = { q: '', cat: 'all' };

    function apply() {
      var q = state.q.trim().toLowerCase();
      var cat = state.cat;
      var visible = 0;

      cards.forEach(function (card) {
        var hay = (card.getAttribute('data-search') || '').toLowerCase();
        var tags = (card.getAttribute('data-tags') || '').toLowerCase();
        var matchQ = !q || hay.indexOf(q) !== -1;
        var matchC = cat === 'all' || tags.indexOf(cat) !== -1;
        var match = matchQ && matchC;
        card.hidden = !match;
        if (match) visible++;
      });

      if (empty) empty.classList.toggle('is-visible', visible === 0);

      // Hide pagination when filtering (filtering is in-page only across current page of results)
      if (pagination) {
        var filtering = !!q || cat !== 'all';
        pagination.style.display = filtering ? 'none' : '';
      }

      // Reflect search clear button visibility
      var wrap = document.querySelector('.np-blog-search');
      if (wrap) wrap.classList.toggle('has-value', !!q);
    }

    function setCat(cat) {
      state.cat = cat;
      chips.forEach(function (c) {
        var pressed = c.getAttribute('data-np-chip') === cat;
        c.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      });
      apply();
    }

    if (search) {
      search.addEventListener('input', function (e) {
        state.q = e.target.value || '';
        apply();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (search) { search.value = ''; search.focus(); }
        state.q = '';
        apply();
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        setCat(chip.getAttribute('data-np-chip'));
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        if (search) search.value = '';
        state.q = '';
        setCat('all');
      });
    }

    // Sticky toolbar shadow on scroll
    var toolbar = document.querySelector('[data-np-toolbar]');
    if (toolbar) {
      var io = new IntersectionObserver(function (entries) {
        toolbar.classList.toggle('is-stuck', entries[0].intersectionRatio < 1);
      }, { threshold: [1], rootMargin: '-1px 0px 0px 0px' });
      io.observe(toolbar);
    }

    apply();
  }

  // -------------------- ARTICLE: reading progress + TOC --------------------
  function initArticle() {
    var article = document.querySelector('[data-np-article]');
    if (!article) return;

    var bodyContent = article.querySelector('[data-np-article-body]');
    if (!bodyContent) return;

    // Build TOC from h2 headings inside the article body
    var headings = Array.prototype.slice.call(bodyContent.querySelectorAll('h2'));
    var tocLists = document.querySelectorAll('[data-np-toc-list]');

    if (headings.length >= 2 && tocLists.length) {
      headings.forEach(function (h, i) {
        if (!h.id) {
          var slug = (h.textContent || ('section-' + i))
            .toLowerCase().replace(/[^\w\s-]/g, '').trim()
            .replace(/\s+/g, '-').slice(0, 60) || ('section-' + i);
          h.id = slug;
        }
      });

      Array.prototype.forEach.call(tocLists, function (list) {
        list.innerHTML = '';
        headings.forEach(function (h) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent;
          a.setAttribute('data-toc-link', h.id);
          li.appendChild(a);
          list.appendChild(li);
        });
      });

      // Active section tracking
      var allTocLinks = document.querySelectorAll('[data-toc-link]');
      var activeId = null;

      function setActive(id) {
        if (id === activeId) return;
        activeId = id;
        Array.prototype.forEach.call(allTocLinks, function (l) {
          l.classList.toggle('is-active', l.getAttribute('data-toc-link') === id);
        });
      }

      var scrollObserver = new IntersectionObserver(function (entries) {
        // Use the most-visible entry currently in upper half of viewport
        var visible = entries.filter(function (e) { return e.isIntersecting; });
        if (visible.length) {
          // Pick the first one that crosses the trigger line
          visible.sort(function (a, b) { return a.target.offsetTop - b.target.offsetTop; });
          setActive(visible[0].target.id);
        }
      }, { rootMargin: '-15% 0px -65% 0px', threshold: 0 });

      headings.forEach(function (h) { scrollObserver.observe(h); });
    } else {
      // Hide TOC containers if not enough headings
      document.querySelectorAll('[data-np-toc]').forEach(function (el) {
        el.style.display = 'none';
      });
    }

    // Reading progress bar
    var progress = document.querySelector('[data-np-progress]');
    if (progress) {
      var rect, scrolled, total;
      var update = function () {
        rect = bodyContent.getBoundingClientRect();
        var top = window.scrollY + rect.top;
        var height = bodyContent.scrollHeight;
        var winH = window.innerHeight;
        var startY = top - winH * 0.15; // start when ~15% visible
        var endY = top + height - winH * 0.5;
        var pct = (window.scrollY - startY) / (endY - startY);
        pct = Math.max(0, Math.min(1, pct));
        progress.style.width = (pct * 100).toFixed(2) + '%';
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    // Share buttons
    var shareTitle = (document.querySelector('meta[property="og:title"]') || {}).content
      || document.title;
    var shareURL = (document.querySelector('link[rel="canonical"]') || {}).href
      || window.location.href;

    var twBtn = document.querySelector('[data-np-share="twitter"]');
    if (twBtn) {
      twBtn.href = 'https://twitter.com/intent/tweet?text=' +
        encodeURIComponent(shareTitle) + '&url=' + encodeURIComponent(shareURL);
    }
    var fbBtn = document.querySelector('[data-np-share="facebook"]');
    if (fbBtn) {
      fbBtn.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareURL);
    }
    var liBtn = document.querySelector('[data-np-share="linkedin"]');
    if (liBtn) {
      liBtn.href = 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(shareURL);
    }
    var copyBtn = document.querySelector('[data-np-share="copy"]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (navigator.clipboard) {
          navigator.clipboard.writeText(shareURL).then(function () {
            var orig = copyBtn.getAttribute('aria-label') || 'Copy link';
            copyBtn.setAttribute('aria-label', 'Link copied!');
            copyBtn.classList.add('is-copied');
            setTimeout(function () {
              copyBtn.setAttribute('aria-label', orig);
              copyBtn.classList.remove('is-copied');
            }, 1800);
          });
        }
      });
    }

    // Smooth-scroll for anchor links inside TOC
    document.querySelectorAll('[data-toc-link]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id && id.charAt(0) === '#') {
          var t = document.getElementById(id.slice(1));
          if (t) {
            e.preventDefault();
            window.scrollTo({ top: t.offsetTop - 70, behavior: 'smooth' });
            // Close mobile TOC after click
            var mob = document.querySelector('.np-toc-mobile[open]');
            if (mob) mob.removeAttribute('open');
          }
        }
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initBlogIndex();
    initArticle();
  });
})();
